@if (hasShopItems()) {
  <div class="free__shipping">
    <span>{{ 'txt-shipping' | translate }}</span>
    <span class="free">{{ 'tag-free' | translate }}</span>
  </div>
}

@if (taxTotal(); as taxTotal) {
  <div class="free__shipping">
    <span>{{ 'txt-estimated-tax' | translate }}</span>
    <span>{{ taxTotal | price }}</span>
  </div>
}

<div class="cart__price">
  <span>{{ 'txt-total' | translate }}</span>
  <span>{{ netTotal() | price }}</span>
</div>

@if (showOuraDiscountBanner()) {
  <div class="ouraBanner">
    <div class="ouraBanner__content">
      <div class="ouraBanner__text">
        <span class="ouraBanner__title">
          {{ 'txt-oura-discount-banner' | translate: { amount: '10%' } }}
        </span>
        <span class="ouraBanner__subTitle">{{ 'oura-ring-discount-description' | translate }}</span>
      </div>
      <img
        class="ouraBanner__image"
        src="https://www.datocms-assets.com/21281/1747900276-iphone15-oura-gen4-illustration-blue.svg"
        alt="iPhone 15 with Oura Ring gen4 image"
      />
    </div>
  </div>
}
